import { apiSlice } from "../../app/api/apiSlice";
import { store } from "../../app/store";
import { CredentialsResponse, LoginGuestResponse, LoginStaffResponse, RefreshTokenResponse, UserCredential, UserCredentialStaff } from "../../types/response";
import { setCredentials } from "./authSlice";

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation({
            query: credentials => ({
                    url: '/api/staff/login',
                    method: 'POST',
                    body: { ...credentials }
            }),
            transformResponse: (response: LoginStaffResponse) => { return response.data }
        }),
        
        userGuestLogin: builder.mutation({
            query: credentials => ({
                    url: '/api/sessions/client-login',
                    method: 'POST',
                    body: { ...credentials }
            }),
            transformResponse: (response: LoginGuestResponse) => { return response.data }
        }),

        guestRegistration: builder.mutation({
            query: credentials => ({
                url: '/api/sessions/registration',
                method: 'POST',
                body: { ...credentials }
            })
        }),

        staffLogOut: builder.mutation<any, void>({
            query: () => ({
                url: '/api/staff/logout',
                method: 'POST',
            }),
        }),

        refreshTokenAccess: builder.mutation<RefreshTokenResponse['data'], void>({
            query: () => ({
                url: '/api/staff/refresh-token',
                method: 'POST',
            }),
            transformResponse: (response: RefreshTokenResponse) => {
                const responseData = response.data
                const credential: UserCredential = {
                    isNewUsername: false,
                    accessToken: responseData?.accessToken,
                    refreshToken: responseData?.refreshToken,
                    staff: {
                        staffID: responseData?.staffID ?? null,
                        firstName: responseData?.firstName ?? '',
                        middleInitial: responseData?.middleInitial ?? '',
                        lastName: responseData?.lastName ?? '',
                        email: responseData?.email ?? '',
                        phone: null,
                        role: responseData?.role,
                        status: responseData?.status ?? '',
                        roleId: null,
                        statusId: null,

                        sessionId: responseData?.sessionID ?? null,
                        clientID: responseData?.clientID ?? null,
                        token: responseData?.token ?? '',
                        userName: responseData?.userName ?? '',
                        generatedUsername: responseData.generatedUserName ?? '',
                        deceasedName: ''
                    }
                };
                store.dispatch(setCredentials(credential));
                return response.data; 
            },
        }),
        getApplicationStatus: builder.query<any[], void>({
            query: () => '/api/fnb/categories',
            transformResponse: (response: any) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: ['Category'],
        }),
    })
})

export const { 
    useLoginMutation,
    useUserGuestLoginMutation,
    useGuestRegistrationMutation,
    // useRefreshTokenMutation,
    useStaffLogOutMutation,
    useRefreshTokenAccessMutation,
    useGetApplicationStatusQuery,
} = authApiSlice


// isNewUsername
// accessToken
// refreshToken

// staffID
// firstName
// middleInitial
// lastName
// email
// phone
// role
// status
// accessToken
// refreshToken

// sessionId
// clientID
// userName
// generatedUserName
// deceasedName
// chapelID
// role
// packageNo
// token
// expiresAt